

export const HomeSlider=[
    {
    id:1,
    img:require('../Images/homePageImg/img17.jpg'),

    // heading:"we provide best Products  As per Your Requirments",
    heading:"We are exporter & suppliers of Welding Electrodes, Filler Wires & Flux Cored Wires",

    text:'we provide best Products  As per Your Requirments',
    // text:'We are exporter & suppliers of Welding Electrodes, Filler Wires & Flux Cored Wires',

  },
  {
    id:2,
    img:require('../Images/homePageImg/slide10.jpg'),
    heading:"Stainless Steel Solutions",
    text:'StainLess Steel Delivered with quality ,by quality People',
  },
  {
    id:3,
    img:require('../Images/homePageImg/slide9.png'),

    heading:"We are largest supplier of",
    text:'Nuts & Bolt,SS Sheet,pipes & Alloy pipes,rod,wire,flange',
    
  },
  {
    id:4,
    img:require('../Images/homePageImg/slide6.png'),
    heading:"INDIA'S LARGEST SUPPLIER OF",
    text:'Nuts&Bolts,Flange,Pipe Fitting, Forged Fittings,Wires and Welding Consumables',
    
  },
  {
    id:5,
    img:require('../Images/homePageImg/slide5.png'),
    heading:"Stainless Steel 304,316 Plates, Sheets & Rod Suppliers In India.",
    text:'We are exporter & suppliers of Stainless Steel Pipes,,sheet,wire,rod.,Carbon Steel Pipes, Alloy Steel Pipes',
    
  },
]

// Fantastic administration, conveyance, and price makes them the obvious choice.',
export const ReviewSlider =[

  {
    id:1,
    img:require( "../Images/reviewImg/img1.jpg"),
    name:"Anthony Joseph",
    text:'I purchase Modi Metals items since I have tested the greater part of the contender services and products and we have confirmed that Modi metals. has the best products available today.' 
  },
  // {
  //   id:2,
  //   img:"https://s3-us-west-2.amazonaws.com/s.cdpn.io/331810/profile-sample5.jpg",
  //   name:"Vikash kumar",
  //   text:"There are such a large number of reasons that Ashok Metal Corporation. is our #1 supplier. Products are dependably in stock and shipments are dependably on time. Finding personal relationships are rare in today's business world, and Ashok Metal Corporation' specialized backing is constantly useful and honest",
  // },
  {
    id:2,
    img:require( "../Images/reviewImg/img2.jpg") ,
    name:"Roshan charan",
    text:'We are entirely satisfied for the quality, consistency and performance of your products.Once again thank you very much for your service  and deep co-operation.',
    
  },
  {
    id:3,
    img:require( "../Images/reviewImg/img3.png"),
    name:"Vikash Trivedi",
    text:'After significant time in the field, I found no producer who remains by its products like Modi metals Corporation.Modi Metals gives the best specialized administration with unmatched industry information.',
    
  },
  {
    id:4,
    img:require( "../Images/reviewImg/img4.png"),
    name:"Morena Crain",
    text:'I work with Modi Metals . since I esteem their association.Running an organization obliges me to go the additional mile for every one of my clients',
    
  },
  {
    id:5,
    img:require( "../Images/reviewImg/img5.png"),
    name:"Virendra chal",
    text:'We are pleased to give Modi Metals. products to our clients on the grounds that the nature of their products is brilliant.Their welcoming staff and productive administration is a reward as well.',
    
  },


]

export const ProductsImg=[
  {
  id:1,
  img:require('../Images/productsMainPageImage/pd1.jpg'),
  heading:"copper",
  text:'Lorem ipsum dolor, sit amet consectetur adipisicing Aspernaturbeatae iusto pariatur laborum magnam eos!',
},
{
  id:2,
  img:require('../Images/productsMainPageImage/pd2.jpg'),
  heading:"Brass",
  text:'Lorem ipsum dolor, sit amet consectetur adipisicing Aspernaturbeatae iusto pariatur laborum magnam eos!',
},
{
  id:3,
  img:require('../Images/productsMainPageImage/pd3.jpg'),
  heading:"Pipes",
  text:'Lorem ipsum dolor, sit amet consectetur adipisicing Aspernaturbeatae iusto pariatur laborum magnam eos!',
  
},
{
  id:4,
  img:require('../Images/productsMainPageImage/pd4.jpg'),
  heading:" wires",
  text:'Lorem ipsum dolor, sit amet consectetur adipisicing Aspernaturbeatae iusto pariatur laborum magnam eos!',
  
},
{
  id:5,
  img:require('../Images/productsMainPageImage/pd5.jpg'),
  heading:"Nutt & Bolts",
  text:'Lorem ipsum dolor, sit amet consectetur adipisicing Aspernaturbeatae iusto pariatur laborum magnam eos!',
  
},
{
  id:6,
  img:require('../Images/productsMainPageImage/pd6.jpeg'),
  heading:"Fittings",
  text:'Lorem ipsum dolor, sit amet consectetur adipisicing Aspernaturbeatae iusto pariatur laborum magnam eos!',
  
},
{
  id:7,
  img:require('../Images/productsMainPageImage/pd7.jpg'),
  heading:" Plates",
  text:'Lorem ipsum dolor, sit amet consectetur adipisicing Aspernaturbeatae iusto pariatur laborum magnam eos!',
  
},
{
  id:8,
  img:require('../Images/productsMainPageImage/pd8.jpg'),
  heading:"SPECIALTY BAR",
  text:'Lorem ipsum dolor, sit amet consectetur adipisicing Aspernaturbeatae iusto pariatur laborum magnam eos!',
  
},
]